export const SITE = {
  name: "click2trip",
  tagline: "The world is one click away.",
  phoneDisplay: "+91 96878 84445",
  phoneRaw: "+919687884445",
  whatsapp: "919687884445",
  email: "sales@click2trip.in",
  address: "7- Premji's Park, Opp. Hotel Evershine, Near Shreenath Travellers, Limda Chowk, Rajkot-360001",
  hours: "Mon–Sat: 10:00 AM – 8:00 PM · Sun: 11:00 AM – 5:00 PM",
  socials: {
    instagram: "https://instagram.com/click_2_trip",
    facebook: "https://facebook.com/click2trip",
    youtube: "https://youtube.com/@click2trip",
  },
  googleReviewUrl: "https://g.page/r/CXc_QkCJBrIgEAE/review",
};

export const waLink = (message) =>
  `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(message)}`;

export const formatINR = (n) => "₹" + Number(n).toLocaleString("en-IN");

export const PACKAGE_TYPES = ["beach", "hill station", "honeymoon", "adventure", "pilgrimage", "family"];
